//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/**
 * @author liuxin
 * @description 多选操作 结果是数组，读取value值
 * @param  label：组件的标签名称
 * @param  options：选项 [{value:'1',name:'选项1',disabled:false}] value:选中的值  name:checkbox显示的名称  disabled:禁用控件，默认不禁用
 * @param  checked：选中的数据 ['1']，通常与disabled:true合并使用
 * @param  disabled：是否全部禁用， 默认false可用
 * @param  showbox：是否显示勾选框， 默认显示 ( false:不显示，则样式会改变)
 */
export default {
    name: "multi-check-radio-list",
    model: { // v-model  对应的变量和事件，默认是value和change
        prop: 'checked',
        event: 'change'
    },
    props: { // 组件参数
        label: String,
        options: Array,
        checked: Array,
        disabled: false,
        showbox: {
            type: Boolean,
            default: true
        },
        radioBoxSelectIndex: {
            type: Number,
            default: 0
        },
        mustSelect: false, //是否必选，必选的时候，去掉所有的选择框
        nameKey: String,
        dataItem: Object  //總數據類型
    },
    methods: {
        handlerChange(item, index) {
            this.dataItem.radioBoxSelectIndex = index
            this.$emit('change', item, index, this.dataItem)
        },
        date(timestamp, separator) {
            let _date = new Date(timestamp*1)
            return `${_date.getFullYear()}${separator || '年'}${_date.getMonth() + 1 < 10 ? `0${_date.getMonth() + 1}` : _date.getMonth() + 1}${separator || '月'}${_date.getDate() < 10 ? `0${_date.getDate()}` : _date.getDate()}${separator || '日'}`
        }
    },
}
